import { customElement, FASTElement, observable } from '@microsoft/fast-element';
import { ThirdPartyEditTemplate as template } from './edit.template';
import { ThirdPartyEditStyles as styles } from './edit.styles';
import { RESURETY_REMAP_VERSION } from '../../../../utils';
import { ThirdPartyIntegration } from '../../../../types';
import { EntityManagement } from '@genesislcap/foundation-entity-management';
import { IThirdPartyService } from '../../../../services/third-party.service';
import { notifyError } from '../../../../utils/notify';

@customElement({
  name: 'edit-third-party',
  template: template,
  styles: styles,
})
export class EditThirdParty extends FASTElement {
  @IThirdPartyService thirdPartyService: IThirdPartyService;

  @observable subscriptionTier: RESURETY_REMAP_VERSION = RESURETY_REMAP_VERSION.LITE;
  @observable data: ThirdPartyIntegration;

  public parentElement: EntityManagement;

  connectedCallback() {
    super.connectedCallback();

    this.parentElement.addEventListener('edit-entity', this.editEntity.bind(this));
  }

  editEntity(e) {
    this.subscriptionTier = e.detail.RESURETY_REMAP_VERSION;
    this.data = e.detail;
  }

  editThirdParty() {
    this.thirdPartyService
      .changeResuretyVersion(this.data.USER_NAME, this.subscriptionTier)
      .then((result) => {
        if (!result.ERROR) {
          this.parentElement.closeModal();
        } else {
          notifyError(result.ERROR[0].TEXT);
        }
      });
  }
}
